export const data = {
    name: "Formations",
    layout: [],
};
export default data;